import { render } from "./transaction-evolution.vue?vue&type=template&id=25ed61cf"
import script from "./transaction-evolution.vue?vue&type=script&lang=js"
export * from "./transaction-evolution.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__